module.exports = __webpack_public_path__ + "media/images/talent/lp/conversion_text_sp-9350e6cdaeb652d207f85202487f6160.svg";